import { useMemo } from "react";

import { UIContext } from "common/contexts/UIContext";

import { urls } from "client/routes";
import { useClinic } from "client/clinics/hooks";

type ClinicUIProviderProps = {
  children: React.ReactNode;
};

const ClinicUIProvider = (props: ClinicUIProviderProps) => {
  const { children } = props;

  const clinic = useClinic();
  const tag = clinic.primary_tag;

  const value = useMemo(() => {
    const isPimsUI = tag.is_pims_ui_enabled && tag.is_pims_backend_enabled;
    const clinicGroupCountry = clinic.group.country;
    const isHdEnabled = tag.is_hd_enabled;

    return {
      isPimsUI,
      isHdEnabled,
      clinicGroupCountry,
      homeUrl: urls.home.root.to(),
    };
  }, [
    clinic.group.country,
    tag.is_hd_enabled,
    tag.is_pims_ui_enabled,
    tag.is_pims_backend_enabled,
  ]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export default ClinicUIProvider;
